import { Switch, Input, Toggle, Description, Label } from './styles'

Switch.Input = Input
Switch.Toggle = Toggle
Switch.Description = Description
Switch.Label = Label

export default Switch
